import { Text } from 'ui-kit/typography'
import { ScenariosError } from '../ScenariosError'
import classes from './ScenariosSearchSummary.module.scss'

export const ScenariosSearchSummary = ({
  total,
  loading,
  isEmptyList,
}: {
  total: number
  loading: boolean
  isEmptyList: boolean
}) => {
  const showResultsNumber = (loading: boolean, total: number) => {
    if (loading) {
      return (
        <Text as={'span'} className={classes.text}>
          Searching for results:
        </Text>
      )
    }
    return (
      <>
        <Text as={'span'} className={classes.number}>
          {total || 0}
        </Text>{' '}
        <Text as={'span'} className={classes.text}>
          {total === 1 ? 'result:' : 'results:'}
        </Text>
      </>
    )
  }

  return (
    <>
      <div className={classes.wrapper}>
        <Text className={classes.result}>
          {showResultsNumber(loading, total)}
        </Text>

        {!isEmptyList && !loading && (
          <Text as={'span'} className={classes.label}>
            Sorted by popularity
          </Text>
        )}
      </div>
      {isEmptyList && !loading && <ScenariosError />}
    </>
  )
}
